import * as React from "react";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkSpacing } from "uitk-react-spacing";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";

const AmenitiesSection = (props: { hotel: Hotel; className: string }) => {
  const { hotel, className } = props;
  const { hotelAmenityCategories } = hotel;

  if (!hotelAmenityCategories?.length) {
    return null;
  }

  return (
    <div className={className}>
      <UitkLayoutFlex space="twelve">
        {hotelAmenityCategories.slice(0, 2).map((amenity) => (
          <UitkLayoutFlex key={amenity.code}>
            <UitkIcon size={UitkIconSize.SMALL} name={amenity.code.toLowerCase()} />
            <UitkSpacing margin={{ inlinestart: "one" }}>
              <span className="uitk-type-300">{amenity.text}</span>
            </UitkSpacing>
          </UitkLayoutFlex>
        ))}
      </UitkLayoutFlex>
    </div>
  );
};

export default AmenitiesSection;
